import { useQuery } from "react-query";

import useDebounce from "../../utils/hooks/useDebounce";
import { getSearchResults } from "../../utils/api";
import { generateUrlParams } from "../queryParams";
import useSetDebouncedUrlParams from "./useSetDebouncedUrlParams";

interface Filters {
  brand?: string[];
  model?: string[];
  brandName?: string[];
  modelName?: string[];
  watchCondition?: string[];
  movement?: string[];
  gender?: string[];
  language?: string[];
  category?: string[];
}

export interface UseSearchOptions {
  limit?: number;
  page?: number;
  sorting?: string;
  filters?: Filters;
  searchLimitting?: boolean;
  keepPreviousData?: boolean;
}

export interface SalesWatchFilters extends UseSearchOptions {
  brandName: string[],
  modelName: string[],
  movement: string[],
  gender: string[],
  watchCondition: string[],
}

export const defaultUseSearchOptions = {
  limit: 5,
  page: 1,
  searchLimitting: true,
  keepPreviousData: true,
}

const useSearch = (
  searchQuery: string,
  isFocused: boolean,
  options: UseSearchOptions = defaultUseSearchOptions
) => {
  const searchTerm = useDebounce(searchQuery.trim(), 500);
  const useQueryOptions = options.searchLimitting ? { enabled: searchTerm.length >= 3 && isFocused } : {};

  const { data, isLoading } = useQuery(
    `search/${encodeURI(searchTerm)}-${options.page}-${options.filters ? Object.entries(options.filters).join("-") : ""}`,
    () => getSearchResults(searchTerm, { ...defaultUseSearchOptions, ...options }),
    useQueryOptions
  );

  useSetDebouncedUrlParams(generateUrlParams(searchTerm, options), 500, !!data);

  return { data, isLoading };
}

export default useSearch;
